import React from 'react';
import Cancel from '@kyruus/react-ikons/Cancel';
import { SvgButton } from './styles';
import { func } from 'prop-types';

const MobileCancel = React.forwardRef((props, ref) => {
  const { onMobileCancelHandler, ...rest } = props;
  return (
    <SvgButton onClick={onMobileCancelHandler} ref={ref} {...rest}>
      <Cancel size="25px" />
    </SvgButton>
  );
});

MobileCancel.propTypes = {
  onMobileCancelHandler: func.isRequired
};

MobileCancel.displayName = 'MobileCancel';

export default MobileCancel;
